import moment from 'moment';
import { DropdownProps } from '@wix/wix-ui-tpa/cssVars';

const TIME_STEP_MINUTES = 15;

export const getCurrentTimeSlotId = (): string => {
  const now = moment();
  const slotMinute = Math.floor(now.minute() / TIME_STEP_MINUTES) * TIME_STEP_MINUTES;
  return `${now.hour()}:${slotMinute}`;
};

export const getMsUntilNextTimeSlot = (): number => {
  const now = moment();
  const nextSlotMinute = (Math.floor(now.minute() / TIME_STEP_MINUTES) + 1) * TIME_STEP_MINUTES;
  const nextSlot = moment(now).minute(nextSlotMinute).second(0).millisecond(0);
  return nextSlot.diff(now);
};

export const refreshTimeSlotsAtNextBoundary = (
  onSlotChange: (slotId: string) => void,
): (() => void) => {
  let timeoutId: ReturnType<typeof setTimeout>;
  const scheduleNext = () => {
    timeoutId = setTimeout(() => {
      onSlotChange(getCurrentTimeSlotId());
      scheduleNext();
    }, getMsUntilNextTimeSlot());
  };
  scheduleNext();
  return () => clearTimeout(timeoutId);
};

const generateAllTimeSlots = (): DropdownProps['options'] => {
  const options: DropdownProps['options'] = [];
  for (let h = 0; h < 24; h++) {
    for (let m = 0; m < 60; m += TIME_STEP_MINUTES) {
      const time = moment({ hour: h, minute: m });
      options.push({
        id: time.format('HH:mm'),
        value: time.format('HH:mm'),
        isSelectable: true,
        isDisabled: false,
        unavailable: false,
      });
    }
  }
  return options;
};

export const allTimeSlots = generateAllTimeSlots();

export const getAvailableTimeSlots = (isToday: boolean): DropdownProps['options'] => {
  if (isToday) {
    const now = moment();
    const filteredOptions = allTimeSlots.filter((option) => {
      const [hours, minutes] = option.id?.split(':')?.map(Number) ?? [];
      return (
        hours > now.hour() || (hours === now.hour() && minutes > now.minute())
      );
    });
    return filteredOptions;
  }
  return allTimeSlots;
};
